import angular from 'angular';

export class ProcessingMetrics {
  public readonly size: any;
  public readonly count: any;

  constructor(size: angular.resource.IResourceService, count: angular.resource.IResourceService, resourceWrapperService: any) {
    this.size = resourceWrapperService.WrapActions(size);
    this.count = resourceWrapperService.WrapActions(count);
  }
}

// Expose as browser global so cross-module bare references (new ProcessingMetrics(...)) resolve
(window as any).ProcessingMetrics = ProcessingMetrics;
